import api from "./api";

const TOKEN_KEY = "relatable_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const isAuthed = () => !!getToken();

export async function adminLogin(password) {
  const res = await api.post("/admin/login", { password });
  setToken(res.data.token);
  return res.data;
}

export async function verifyAdmin() {
  try {
    await api.get("/admin/me");
    return true;
  } catch {
    clearToken();
    return false;
  }
}
